export const getOnboardSteps = (t: (text: string) => string, onBoardStart: boolean) => {
  if (!onBoardStart) return [];
  return [
    {
      disableBeacon: true,
      target: 'redirect-6',
      placement: 'top',
      data: {
        navigateBefore: 'sensors',
        previousItemIndex: 1, //Index of the last item that had a mounted target from /src/pages/Sensors/helpers/getOnboardSteps.js
      },
    },
    {
      target: '#tourStep-20',
      content: t(
        'A variety of reports are also available, including a list of archived Action Items for case history.',
      ),
      placement: 'top',
    },
    {
      target: 'finish',
      data: {
        stepFinish: true,
      },
    },
  ];
};
